// extracted by mini-css-extract-plugin
module.exports = {"dpuDetailE":"E_dpuDetailE__nRS1A"};